export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig()
    const disableThirdParty = ['local', 'dev'].includes(String(config.public.APP_ENV)) || import.meta.dev
    if (disableThirdParty) {
        return
    }

    useHead({
        script: {
            src: 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=P9e6fb',
            type: 'application/javascript',
            async: true
        }
    });
});
